"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Variable_1 = __importDefault(require("./Variable"));
var VariableService = (function () {
    function VariableService(accountQuoteSettings, uniqueId) {
        var _this = this;
        this.accountQuoteSettings = accountQuoteSettings;
        this.uniqueId = uniqueId;
        this.getAllVariables = function () {
            return _this.variables.filter(function (variable) { return !variable.isDeleted; }).map(function (variable) { return new Variable_1.default(_this, variable); });
        };
        this.search = function (searchTerm) {
            return _this.variables
                .filter(function (variable) { return !variable.isDeleted && variable.name.toLowerCase().includes(searchTerm.toLowerCase()); })
                .map(function (variable) { return new Variable_1.default(_this, variable); });
        };
        this.getVariable = function (id) {
            var variable = _this.variables.find(function (variable) { return variable.id === id; });
            return variable ? new Variable_1.default(_this, variable) : null;
        };
        this.getDefaultVariableId = function () {
            var _a, _b;
            return (_b = (_a = _this.variables.find(function (variable) { return !variable.isDeleted; })) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
        };
        this.deleteVariable = function (id) {
            var variableObject = _this.variables.find(function (variable) { return variable.id === id; });
            if (variableObject) {
                variableObject.isDeleted = true;
            }
        };
        this.updateVariable = function (id, variable) {
            var _a;
            var clone = __assign(__assign({}, variable), { defaultAmount: (_a = variable.defaultAmount) !== null && _a !== void 0 ? _a : 0 });
            var index = _this.variables.findIndex(function (variable) { return variable.id === id; });
            if (index < 0) {
                throw new Error("Could not find variable with that id");
            }
            _this.accountQuoteSettings.variables[index] = clone;
        };
        this.addVariable = function () {
            return _this.accountQuoteSettings.variables.push({
                id: _this.uniqueId(),
                name: "New Variable",
                defaultAmount: 250,
                unitName: "Hour",
                isDeleted: false,
                ifUnder: {
                    isActive: false,
                    unitThreshold: 0,
                    unitName: "Hour",
                    amount: 0,
                },
                ifOver: {
                    isActive: false,
                    unitThreshold: 0,
                    unitName: "Hour",
                    amount: 0,
                },
            });
        };
        this.getUnitNames = function () {
            return _this.accountQuoteSettings.unitNames;
        };
        this.deleteUnit = function (name) {
            (0, lodash_1.pull)(_this.accountQuoteSettings.unitNames, name);
        };
        this.addUnit = function (name) {
            _this.accountQuoteSettings.unitNames.push(name);
        };
        if (!accountQuoteSettings.unitNames) {
            accountQuoteSettings.unitNames = [];
        }
        if (!accountQuoteSettings.variables) {
            accountQuoteSettings.variables = [];
        }
    }
    Object.defineProperty(VariableService.prototype, "variables", {
        get: function () {
            return this.accountQuoteSettings.variables;
        },
        enumerable: false,
        configurable: true
    });
    return VariableService;
}());
exports.default = VariableService;
